import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';

import RailNavigation from 'Containers/navigation/railNav';
import { APP_NAV_LINKS, NAVIGATION_TYPES } from 'Utils/appShell';

const styles = theme => ({
  navItemColorPrimary: {
    color: theme.palette.text.navigation,
    '&$disabled': {
      opacity: 0.4,
    },
  },
  lightTooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },
  wrapperPlacementRight: {
    width: 'auto',
    display: 'inline-flex',
    flexDirection: 'row',
  },
  labelContainerPlacementRight: {
    paddingLeft: 6, // hard-coding similar to 'Tab' api implementation
  },
  enlargedIcon: {
    width: '1.4em',
    height: '1.4em',
  },
});

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    const { location } = props;

    let selectedNavIndex = APP_NAV_LINKS.findIndex(
      e => e.navRoute === location.pathname
    );

    this.state = {
      selectedNavIndex: selectedNavIndex !== -1 ? selectedNavIndex : 0,
      navItems: APP_NAV_LINKS,
    };
  }

  handleAppNavigation = toPath => {
    const { history, location } = this.props;
    const { navItems } = this.state;
    const selectedNavItem = navItems.find(e => e.navRoute === toPath);
    if (selectedNavItem && selectedNavItem.navRoute !== location.pathname) {
      history.push(toPath);
    }
  };

  render() {
    const { variant } = this.props;
    const { selectedNavIndex, navItems } = this.state;

    let navMenu = null;
    switch (variant) {
      case NAVIGATION_TYPES.RAIL:
        navMenu = (
          <RailNavigation
            navItems={navItems}
            initIndex={selectedNavIndex}
            onNavChange={this.handleAppNavigation}
          />
        );
        break;
    }

    return navMenu;
  }
}

Navigation.propTypes = {
  /**
   * The type of navigation component to display.
   * - 'rail' displays a vertical nav bar
   * - 'tab' displays a horizontal nav bar that fills the containers width, with swipable list of nav items
   */
  variant: PropTypes.oneOf([NAVIGATION_TYPES.RAIL, NAVIGATION_TYPES.TAB]),
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

Navigation = compose(
  withRouter,
  withStyles(styles, { withTheme: true })
)(Navigation);

export default Navigation;
